
import { computed, defineComponent, PropType, ref, toRefs } from 'vue'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { downloadMetaDiscountAssociations } from '../../../dependency-injection'
import { Discount } from '../../../domain/Discount'
import CFileDownload from '../CFileDownload.vue'
import { useContext } from '../../../../../application/composables/useContext'

export default defineComponent({
  name: 'CReadonlyMetaDiscountAssociations',
  components: { CFileDownload },
  props: {
    discount: {
      type: Object as PropType<Discount>,
      required: true,
    },
  },
  setup(props) {
    const i18n = useI18nForVue2()

    const { discount } = toRefs(props)

    const { isRetail } = useContext()

    const isLoading = ref(false)
    const downloadAssociationFile = async () => {
      isLoading.value = true
      await downloadMetaDiscountAssociations.execute(discount.value.reference, discount.value.participants!)
      isLoading.value = false
    }

    const placeholder = computed(() => {
      const { discountablesCount, productsCount } = discount.value || {}
      if (isRetail.value) {
        return `${productsCount} ${i18n.t('ctx.discount.detail.imported-products')}`
      }
      return `${discountablesCount} ${i18n.t('ctx.discount.detail.imported-offers')}`
    })

    return {
      hasAssociations: computed(() => Boolean(discount.value.discountablesCount)),
      placeholder,
      downloadAssociationFile,
      isLoading,
    }
  },
})
